import React from 'react';

export const HappyFaceIcon = (props: JSX.IntrinsicElements['svg']) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M.5 8a7.5 7.5 0 1015 0 7.5 7.5 0 00-15 0v0z" stroke="currentColor" />
        <path
            d="M3.756 9.5a.5.5 0 00-.471.667 5 5 0 009.43 0 .5.5 0 00-.471-.667H3.756zM12.329 7A1.5 1.5 0 009.5 7M6.5 7a1.5 1.5 0 00-2.829 0"
            stroke="currentColor"
        />
    </svg>
);
